import { createApi } from "@reduxjs/toolkit/query/react";
import { Endpoints, convertTag } from "services/urls";
import { baseQuery } from "utils/baseQuery";
import { apiHelper } from "../utils/apiHelper";
import { METHODS } from "../config";
import {
  IMessage,
  IMessageList,
  IMessageListQuery,
  ISendMessageInput,
} from "../types/message.types";

const MESSAGE_TAGS = {
  list: "messages-list",
  detail: "message-detail",
};

const MessageApi = createApi({
  reducerPath: "message-api",
  baseQuery: baseQuery(),
  tagTypes: [MESSAGE_TAGS.list, MESSAGE_TAGS.detail],
  endpoints: (builder) => ({
    messageList: builder.query<IMessageList, IMessageListQuery>({
      providesTags: [convertTag(MESSAGE_TAGS.list)],
      query: (body) => apiHelper(Endpoints.messages.list, body),
    }),
    messageDetail: builder.query<{ data: IMessage }, { message: string }>({
      providesTags: [convertTag(MESSAGE_TAGS.detail)],
      query: (body) => apiHelper(Endpoints.messages.detail, body),
    }),
    sendMessage: builder.mutation<void, ISendMessageInput>({
      invalidatesTags: [convertTag(MESSAGE_TAGS.list)],
      query: (body) => ({
        url: Endpoints.messages.send,
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const {
  useMessageListQuery,
  useMessageDetailQuery,
  useSendMessageMutation,
  useLazyMessageDetailQuery,
} = MessageApi;
export { MessageApi, MESSAGE_TAGS };
